import { useMemo } from "react";
import { IMinerHashSetting } from "./MinerHashSetting.props";
import { ROUTES_E } from "@utils/RoutsName";
import { useMinerContext } from "../MinerContext";
import { useMe, useSettings } from "@utils/hooks/useMe";

interface IMinerHashSettingControl {
  readonly canClick: boolean;

  goToSetting(): void;
}

export const useMinerHashSettingControl = (
  props: IMinerHashSetting
): IMinerHashSettingControl => {
  const me = useMe();
  const settings = useSettings();
  const { miner } = useMinerContext();
  const canClick = useMemo(() => {
    if (me?.is_admin && miner.admin_mining_do) {
      return true;
    }
    if (!me?.is_admin) {
      const find = settings.find(
        (s) => Number(s.id) === Number(props.settingid)
      );
      if (find) {
        return true;
      } else return false;
    }
    if (miner.customer_email !== me?.email.value) return false;

    return !!props.children && props.children !== "---" && !!props.settingid;
  }, [props.children, props.settingid]);

  const goToSetting = () => {
    window.open(`${ROUTES_E.SETTINGS}?pool=${props.children}`, "_blank");
  };

  return {
    canClick,

    goToSetting,
  };
};
